import React from 'react'
import { AphroditeIframe } from '@ui'
import { accessToken } from '@stores/apollo'
import Appbar from '../Appbar'

export default function GlobalMap({ pinLeftNav }: any) {
  const url = '/ap/Current/global'

  return (
    <>
      <Appbar title="Global Map" />
      <AphroditeIframe token={accessToken} path={url} pinLeftNav={pinLeftNav} />
    </>
  )
}
